import { ResourceBaseService } from "@/core/common/resource-base/resource-base.service";
import { ApiHttpClient } from "@/core/common/http/api-http-client";
import { CollectiveAgreementHolidayDto } from "./collective-agreement-holiday.dto";
import { CreateCollectiveAgreementHolidayDto } from "./create-collective-agreement-holiday.dto";
import { UpdateCollectiveAgreementHolidayDto } from "./update-collective-agreement-holiday.dto";
import { CopyCollectiveAgreementHolidaysDto } from "./copy-collective-agreement-holidays.dto";
import { HttpRequest } from "@/core/common/http/http-request";
import { plainToInstance } from "class-transformer";

export class CollectiveAgreementHolidaysResource extends ResourceBaseService<
  CollectiveAgreementHolidayDto,
  CreateCollectiveAgreementHolidayDto,
  UpdateCollectiveAgreementHolidayDto
> {
  protected EntityDto = CollectiveAgreementHolidayDto;
  protected CreateEntityDto = CreateCollectiveAgreementHolidayDto;
  protected UpdateEntityDto = UpdateCollectiveAgreementHolidayDto;

  constructor(protected readonly apiHttpClient: ApiHttpClient) {
    super(apiHttpClient, "/collective-agreement-holidays");
  }

  async bulkCreate(holidays: CreateCollectiveAgreementHolidayDto[]): Promise<CollectiveAgreementHolidayDto[]> {
    const result = await this.apiHttpClient.request<
      { bulk: CreateCollectiveAgreementHolidayDto[] },
      CollectiveAgreementHolidayDto[]
    >(
      HttpRequest.create({
        url: `${this.resourceUrl}/bulk`,
        method: "POST",
        auth: true,
        body: { bulk: plainToInstance(this.CreateEntityDto, holidays, { excludeExtraneousValues: true }) },
      })
    );
    return plainToInstance(this.EntityDto, result);
  }

  async copyCalendar(data: CopyCollectiveAgreementHolidaysDto): Promise<CollectiveAgreementHolidayDto[]> {
    const result = await this.apiHttpClient.request<
      CopyCollectiveAgreementHolidaysDto,
      CollectiveAgreementHolidayDto[]
    >(
      HttpRequest.create({
        url: `${this.resourceUrl}/copy`,
        method: "POST",
        auth: true,
        body: data,
      })
    );
    return plainToInstance(this.EntityDto, result);
  }
}
